import { Injectable } from '@angular/core';
import {
  ICommentData,
  ILawyerData,
  IPaymentHash,
} from 'src/app/core/common/interfaces';
import { HttpService } from 'src/app/core/services/http.service';
import { INewsData } from '../../core/common/interfaces';
import { IContractData, ICreateCustomContractData, IEducation, IEduDetails, IEnrolledCourseData, IPetition, IRatingBody, IRatingRespondBody, ISearchResult } from './p-interface';

@Injectable()
export class ApiService {
  constructor(private _httpService: HttpService) { }
  private _urlLawyerList = 'lawyer/lawyer-list/';
  private _urlLawyerDetail = 'lawyer/lawyer-info/';
  private _urlGetComment = 'comment/comment-list/';
  private _urlReadyContract = 'contract/ready-contract/list/';
  private _urlCustomContract = 'contract/custom-contract/list/';
  private _urlSmartContract = 'contract/smart-contract/list/';
  private _urlCreatePaymentHash = 'payment/payment-hash/';
  private _urlCreateCustomContract = 'contract/custom-contract-instance/create-instance/';
  private _urlNewsList = 'article/active-articles-list/';
  private _urlNewsDetail = 'article/article/';
  private _urlNewsSearch = 'article/search-article/';
  private _urlPetition = 'petition/petition-list/';
  private _urlEducation = 'learning/search/';
  private _urlCategory = 'category/category-list/';
  private _urlRating = 'comment/';
  private _urlEduDetails = 'learning/course/';
  private _urlPetitionDetails = 'petition/petition/';
  private _urlGetUserCoursesList ='learning/enrollment/';

  getLawyerList(page: number) {
    return this._httpService.getSuccessResult<ILawyerData[]>({
      path: this._urlLawyerList,
      method: 'POST',
      body: {
        page_index: page,
        page_size: 12,
      },
      noAuth: true
    }, [])
  }

  getNewsList(body: {page_index: number, page_size: number, search?: string}) {
    return this._httpService.getSuccessResult<INewsData[]>(
      {
        path: this._urlNewsList,
        method: 'GET',
        noAuth: true,
        body: body
      }, []
    );
  }

  /** @deprecated Use getNewsList instead. */
  searchNewsList(params: { search?: string }) {
    return this._httpService.getSuccessResult<INewsData[]>(
      {
        path: this._urlNewsSearch,
        params,
        method: 'GET',
      }, []
    );
  }

  getNewsDetail(uuid: string) {
    return this._httpService.getSuccessResult<INewsData>(
      {
        path: this._urlNewsDetail,
        method: 'GET',
        params: { uuid },
        noAuth: true
      }, {}
    );
  }

  getLawyerDetail(uuid: string) {
    return this._httpService.getSuccessResult<ILawyerData>(
      {
        path: this._urlLawyerDetail,
        method: 'GET',
        params: { uuid: uuid },
        noAuth: true
      }, {}
    );
  }

  getLawyerComment(body: { obj_uuid: string; api_type: string }) {
    return this._httpService.getSuccessResult<ICommentData[]>(
      {
        path: this._urlGetComment,
        method: 'GET',
        params: body,
        noAuth: true
      }, []
    );
  }

  getReadyContractList(page: number) {
    return this._httpService.getSuccessResult<IContractData[]>(
      {
        path: this._urlReadyContract,
        method: 'POST',
        body: {
          page_index: page,
          page_size: 12,
        },
        noAuth: true
      }, []
    );
  }

  getCustomContractList(page: number) {
    return this._httpService.getSuccessResult<IContractData[]>(
      {
        path: this._urlCustomContract,
        method: 'POST',
        body: {
          page_index: page,
          page_size: 12,
        },
        noAuth: true
      }, []
    );
  }

  getSmartContractList(page: number) {
    return this._httpService.getSuccessResult<IContractData[]>(
      {
        path: this._urlSmartContract,
        method: 'POST',
        body: {
          page_index: page,
          page_size: 12,
        },
        noAuth: true
      }, []
    );
  }

  createPaymentHash(body: { product_uuid: string; usage: string }) {
    return this._httpService.getSuccessResult<IPaymentHash>({
      method: 'POST',
      path: this._urlCreatePaymentHash,
      body: body,
    });
  }

  createCustomContract(uuid: string) {
    return this._httpService.getSuccessResult<ICreateCustomContractData>({
      method: 'POST',
      path: this._urlCreateCustomContract,
      body: { custom_contract_uuid: uuid },
    });
  }

  getPetitionList(page: number) {
    return this._httpService.getSuccessResult<IPetition[]>({
      method: 'POST',
      path: this._urlPetition,
      body: { page_index: page, page_size: 12 },
      noAuth: true
    }, []);
  }

  getEducationList(params, is_active:boolean) {
    return this._httpService.getSuccessResult<IEducation[]>({
      method: 'POST',
      path: this._urlEducation,
      body: { ...params, page_size: 12, is_active: is_active },
      noAuth: true
    }, []);
  }

  getEducationDetails(uuid: string, isLogin: boolean = false) {
    return this._httpService.getSuccessResult<IEduDetails>({
      method: 'GET',
      path: this._urlEduDetails,
      params: { course_uuid : uuid },
      noAuth: !isLogin
    },{})
  }

  getCategory() {
    return this._httpService.getSuccessResult({
      method: 'POST',
      path: this._urlCategory,
      body: { type: ['learning'] },
      noAuth: true
    })
  }

  sendRating(body: IRatingBody) {
    return this._httpService.getSuccessResult<IRatingRespondBody>({
      method: "POST",
      path: this._urlRating,
      body: body
    })
  }

  mainSearchBar(text: string, pagesize?: number){
    return this._httpService.getSuccessResult<ISearchResult[]>({
      method: 'POST',
      path: 'search/',
      body: {text: text, page_size: pagesize ?? 3}
    },[])
  }

  getPetitionDetails(petition_uuid: string){
    return this._httpService.getSuccessResult<IPetition>({
      method: 'GET',
      path: this._urlPetitionDetails,
      body: { petition_uuid:  petition_uuid},
      noAuth: true
    }, {});
  }

  getUserCourse(){
    return this._httpService.getSuccessResult<IEnrolledCourseData[]>({
      method: 'GET',
      path: this._urlGetUserCoursesList,
      params: { page_size: 100 }
    },
    []
    );
  }
}
